import { VFlow } from 'bold-ui'
import React from 'react'

import { IconTextCard } from '../../components/IconTextCard'
import { GrupoMedicoesTipoModel, tipoMedicaoRecord } from '../../types/MedicaoModel'
import { MedicoesDescription } from './MedicoesDescription'

interface MedicoesListCardProps {
  medicoes: GrupoMedicoesTipoModel[]
  isListMedicaoAnterior?: boolean
}

export const MedicoesListCard = (props: MedicoesListCardProps) => {
  const { medicoes, isListMedicaoAnterior } = props

  return (
    <VFlow vSpacing={0.5}>
      {medicoes.map((medicao) => {
        const constMedicao = tipoMedicaoRecord[medicao.tipo]
        return (
          <IconTextCard
            icon={constMedicao.icon}
            iconColor={constMedicao.colorScale}
            iconPec={constMedicao.iconPec}
            label={constMedicao.label}
            key={medicao.tipo}
            value={
              <MedicoesDescription
                values={medicao.medicoes}
                unidadeMedida={constMedicao.unidadeMedida}
                isMedicaoAnterior={isListMedicaoAnterior}
              />
            }
          />
        )
      })}
    </VFlow>
  )
}
